import { PricingPortalAPI } from "../../../apis/pricing-api";
import { handlePostAction } from "../../../utils/event-api-invoke";
import { getConsumableProductAPIPostSchema, getConsumableProductAuditInfoSchema } from "../consumable-product/create/schema";

let _isError = false;

const _getPreviousState = (data) => {
  try {
    let _prevState = {};

    _prevState.LongName = data?.consumableProduct?.LongName || "";
    _prevState.ShortName = data?.consumableProduct?.ShortName || "";
    _prevState.MeasurementUnit = data?.consumableProduct?.MeasurementUnit || "";
    _prevState.ContractCost = data?.consumableProduct?.ContractCost || 0;
    _prevState.ICABSCode = data?.consumableProduct?.ICABSCode || "";
    _prevState.Toxic = data?.consumableProduct?.Toxic || false;
    _prevState.ApplicationUnit = data?.consumableProduct?.ApplicationUnit || "";
    _prevState.ApplicationUnitCost = data?.consumableProduct?.ApplicationUnitCost || 0;
    _prevState.GMMaterial = data?.consumableProduct?.GMMaterial || 0;


    if (data?.replacementProducts && data.replacementProducts.length > 0) {
      const products = data.replacementProducts;
      _prevState.replacementProduct = products.map((product) => ({
        StartFrequencyReposition: product.StartFrequencyReposition || "",
        EndFrequencyReposition: product.EndFrequencyReposition || "",
        MaintenancePercentage: product.MaintenancePercentage || "",
        Id: product.ReplaceProductId || "",
        ...(data?.Deleted && { Action: "DELETE" }),
      }));
    }


    return JSON.stringify(_prevState);
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const _getCurrentState = (data) => {
  try {
    let _currentState = {};

    _currentState.LongName = data?.consumableProduct?.LongName || "";
    _currentState.ShortName = data?.consumableProduct?.ShortName || "";
    _currentState.MeasurementUnit = data?.consumableProduct?.MeasurementUnit || "";
    _currentState.ContractCost = data?.consumableProduct?.ContractCost || 0;
    _currentState.ICABSCode = data?.consumableProduct?.ICABSCode || "";
    _currentState.Toxic = data?.consumableProduct?.Toxic || false;
    _currentState.ApplicationUnit = data?.consumableProduct?.ApplicationUnit || "";
    _currentState.ApplicationUnitCost = data?.consumableProduct?.ApplicationUnitCost || 0;
    _currentState.GMMaterial = data?.consumableProduct?.GMMaterial || 0;

    if (data?.replacementProducts && data.replacementProducts.length > 0) {
      const products = data.replacementProducts.filter(product =>
        !product.deleted || (product.deleted && product.ReplaceProductId)
      );
      _currentState.replacementProduct = products.map((product) => ({
        StartFrequencyReposition: product.StartFrequencyReposition || "",
        EndFrequencyReposition: product.EndFrequencyReposition || "",
        MaintenancePercentage: product.MaintenancePercentage || "",
        ...(product.ReplaceProductId && { Id: product.ReplaceProductId }),
        Action: product.deleted ? "DELETE" : product.ReplaceProductId ? "EDIT" : "CREATE"
      }));
    }
    return JSON.stringify(_currentState);
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const getAuditInfo = (data, auditConfig) => {
  try {
    let _auditSchema = getConsumableProductAuditInfoSchema();
    let _currentState = {};
    let _isDeleted = data?.Deleted;
    Object.keys(data).forEach((key) => {
      _currentState[key] = data[key];
    });

    _auditSchema.auditInfo[0].shortDesc = data?.consumableProduct?.ShortName;
    _auditSchema.auditInfo[0].currentState = _isDeleted ? "{}" : _getCurrentState(data);
    if (auditConfig.editConsumableProductId) {
      _auditSchema.auditInfo[0].LocationKey = auditConfig.editConsumableProductId;
      _auditSchema.auditInfo[0].Action = _isDeleted ? "DELETE" : "EDIT";
      _auditSchema.auditInfo[0].previousState = _getPreviousState(auditConfig.formdata);
    } else {
      _auditSchema.auditInfo[0].Action = "CREATE";
    }

    return _auditSchema;
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const getPostPayload = (data, config) => {
  try {

    let _postSchema = getConsumableProductAPIPostSchema(config.countryCode, config.businessCode);

    _postSchema.consumableproduct[0].LongName = data?.consumableProduct?.LongName || "";
    _postSchema.consumableproduct[0].ShortName = data?.consumableProduct?.ShortName || "";
    _postSchema.consumableproduct[0].MeasurementUnit = data?.consumableProduct?.MeasurementUnit || "";
    _postSchema.consumableproduct[0].ContractCost = data?.consumableProduct?.ContractCost || 0;
    _postSchema.consumableproduct[0].ICABSCode = data?.consumableProduct?.ICABSCode || "";
    _postSchema.consumableproduct[0].Toxic = data?.consumableProduct?.Toxic || false;
    _postSchema.consumableproduct[0].ApplicationUnit = data?.consumableProduct?.ApplicationUnit || "";
    _postSchema.consumableproduct[0].ApplicationUnitCost = data?.consumableProduct?.ApplicationUnitCost || 0;
    _postSchema.consumableproduct[0].GMMaterial = data?.consumableProduct?.GMMaterial || 0;

    if (config.editConsumableProductId) {
      _postSchema.consumableproduct[0].ConsumableProductId = config.editConsumableProductId;
      _postSchema.consumableproduct[0].Deleted = data.Deleted ? data.Deleted : false;
    }

    if (data?.replacementProducts && data.replacementProducts.length > 0) {
      const products = data.replacementProducts.filter(product =>
        !product.deleted || (product.deleted && product.ReplaceProductId)
      );
      _postSchema.consumableproduct[0].replacementProduct = products.map((product) => ({
        StartFrequencyReposition: product.StartFrequencyReposition || "",
        EndFrequencyReposition: product.EndFrequencyReposition || "",
        MaintenancePercentage: product.MaintenancePercentage || "",
        ReplaceProductId: product.ReplaceProductId || "",
        Deleted: product.deleted || false

      }));
    }


    return _postSchema;
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const getReplacementProduct = async (EditConsumableProductId, settingsConfig) => {
  let response = await PricingPortalAPI.getFilterList(
    settingsConfig.businessCode,
    settingsConfig.countryCode,
    "getReplacementProductList",
    "replacepercentageproduct",
    `&productid=${EditConsumableProductId}`
  );
  return response
}
const saveConsumableProduct = async (data, uihandler) => {
  let status = {
    responseStatus: null,
    error: null,
  };
  const {
    editConsumableProductId,
    settingsConfig: { businessCode, countryCode },
    formdata
  } = uihandler;
  try {
    let _auditInfo = getAuditInfo(data, { editConsumableProductId, formdata });
    let _postPayload = getPostPayload(data, { editConsumableProductId, businessCode, countryCode });

    let _postRequest = { ..._postPayload, ..._auditInfo };

    let res = await handlePostAction(_postRequest, "consumableproduct");
    if (res && res.status && res.status === 200) {
      if (res.data && res.data.response && res.data.response.errorNumber) {
        _isError = true;
        const errorMessage = res.data.response.errorDescription ? res.data.response.errorDescription : "Consumable product creation failed";
        status.erroMessage = errorMessage;
      } else {
        status.responseStatus = res.status;
      }
    }

  } catch (err) {
    _isError = true;
    alert(err);
  } finally {
    return { ...status, error: _isError };
  }
};

export { saveConsumableProduct, getReplacementProduct };
